import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=865077f4&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('865077f4')) {
      api.createRecord('865077f4', component.options)
    } else {
      api.reload('865077f4', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=865077f4&", function () {
      api.rerender('865077f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/account/Account.vue"
export default component.exports